export enum Pages {
  Home = '',
  Editions = 'editions',
  Levels = 'levels',
  Consent = 'consent',
  Survey = 'survey',
  Privacy = 'privacy',
  Terms = 'terms',
  About = 'about',
  Methodology = 'methodology',
  Partners = 'partners',
  Contact = 'contact',
  Sandbox = 'sandbox',

  Share = 'share',

  MarkdownDemo = 'markdown-demo',
}
